import { render, staticRenderFns } from "./TeamLeadEmailComponent.vue?vue&type=template&id=5ae2361d&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae2361d')) {
      api.createRecord('5ae2361d', component.options)
    } else {
      api.reload('5ae2361d', component.options)
    }
    module.hot.accept("./TeamLeadEmailComponent.vue?vue&type=template&id=5ae2361d&", function () {
      api.rerender('5ae2361d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/TeamLeadEmailComponent.vue"
export default component.exports